// extracted by mini-css-extract-plugin
export var fadeIn = "_8e-0";